module.exports = __webpack_public_path__ + "static/winter1-9afee751bf58632b31a02cdb1fba6a54.jpg";